document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const json = section.querySelector('[data-product-json]');
    const master = section.querySelector('.variant-select');
    const optionSelects = [...section.querySelectorAll('[data-option-index]')];
    if (!json || !master || !optionSelects.length) return;
    const variants = JSON.parse(json.textContent);
    const syncVariant = () => {
      const values = optionSelects.map((select) => select.value);
      const match = variants.find((variant) => values.every((value, index) => variant.options[index] === value));
      if (match) {
        master.value = match.id;
        const price = section.querySelector('.product-price');
        const selectedOption = master.options[master.selectedIndex];
        if (price && selectedOption.dataset.price) price.textContent = selectedOption.dataset.price;
      }
    };
    optionSelects.forEach((select) => select.addEventListener('change', syncVariant));
  });
});
